import {
  addShopDeviceApi,
  updateShopDeviceApi,
  deleteShopDeviceApi,
  queryShopDeviceListApi,
  queryPrinterConfigApi,
  addPrinterConfigApi,
  deletePrinterConfigApi,
  updatePrinterConfigApi,
  getPrinterConfigByIdApi,
  printerTestApi,
  feieAddPrinterApi,
  feieGetPrintStatusApi,
  ylyPrintSetSoundApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  添加门店设备
  async addShopDeviceAction(context, param) {
    const res = await addShopDeviceApi(param)
    return res
  },
  //  更新门店设备
  async updateShopDeviceAction(context, param) {
    const res = await updateShopDeviceApi(param)
    return res
  },
  //  删除门店设备
  async deleteShopDeviceAction(context, param) {
    const res = await deleteShopDeviceApi(param)
    return res
  },
  //  查询门店设备列表
  async queryShopDeviceListAction(context, param) {
    const res = await queryShopDeviceListApi(param)
    return res
  },
  //  查询打印机列表
  async queryPrinterConfigAction(context, param) {
    const res = await queryPrinterConfigApi(param)
    return res
  },
  //  添加打印机
  async addPrinterConfigAction(context, param) {
    const res = await addPrinterConfigApi(param)
    return res
  },
  //  删除打印机
  async deletePrinterConfigAction(context, param) {
    const res = await deletePrinterConfigApi(param)
    return res
  },
  //  修改打印机
  async updatePrinterConfigAction(context, param) {
    const res = await updatePrinterConfigApi(param)
    return res
  },
  //  根据id获得打印机信息
  async getPrinterConfigByIdAction(context, param) {
    const res = await getPrinterConfigByIdApi(param)
    return res
  },
  //  打印测试
  async printerTestAction(context, param) {
    const res = await printerTestApi(param)
    return res
  },
  //  把打印机添加到飞鹅平台中
  async feieAddPrinterAction(context, param) {
    const res = await feieAddPrinterApi(param)
    return res
  },
  //  获取飞鹅打印机状态
  async feieGetPrintStatusAction(context, param) {
    const res = await feieGetPrintStatusApi(param)
    return res
  },
  //  易联云打印机声音调节
  async ylyPrintSetSoundAction(context, param) {
    const res = await ylyPrintSetSoundApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
